import { ReactNode } from "react";
import close from "../../assets/images/icons/x.svg";

interface IClosableTag {
  onClose: () => void;
  title: string | ReactNode;
}

const ClosableTag: React.FC<IClosableTag> = ({ title, onClose }) => {
  return (
    <span
      id="badge-dismiss-primary-text"
      className="me-2 inline-flex h-fit w-fit items-center rounded-lg bg-InputFieldColor px-2 py-1 text-sm text-secondaryDark"
    >
      {title}
      <button
        type="button"
        onClick={onClose}
        className="ms-2 inline-flex items-center rounded-sm bg-transparent p-1 text-sm text-secondaryDark"
        data-dismiss-target="#badge-dismiss-primary-text"
        aria-label="Remove"
      >
        <img src={close} alt="" className="h-3 w-3" />
      </button>
    </span>
  );
};
export default ClosableTag;
